import { axiosHrClient } from '../plugins/axios'

const history = {
  namespaced: true,

  actions: {
    getAddress(ctx, guid) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(`/hr/employees/${guid}/addresss`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getFamilies(ctx, guid) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(`/hr/employees/${guid}/families`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getWorks(ctx, guid) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hr/employees/${guid}/workhistories`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getEducations(ctx, guid) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hr/employees/${guid}/educations`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getFames(ctx, guid) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(`/hr/employees/${guid}/fames`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getLeave(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hr/employees/${payload.guid}/leaves/startdate/${payload.startDate}/enddate/${payload.endDate}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getLeaveDocumentDownload(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrleave/reporteform/employees/${payload.guid}/leaveorders/${payload.leaveOrderID}`,
            { responseType: 'blob' }
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getLeaveEdu(ctx, guid) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hr/employees/${guid}/educationleaves`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getExecutives(ctx, guid) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hr/employees/${guid}/executives`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getTechnicalskills(ctx, guid) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hr/employees/${guid}/technicalskills`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getTraining(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `hr/employees/${payload.guid}/trainings/startdate/${payload.startDate}/enddate/${payload.endDate}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getTrainningactiontypes(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrreference/trainningactiontypes/${payload.dataVal}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getCountry() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(`hrreference/country`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    postTraining(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `hr/employees/trainings`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    delTraining(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.delete(
            `hr/employees/${payload.empId}/trainings/${payload.trainNum}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getTrainingDataByNumber(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `hr/employees/${payload.empId}/trainings/${payload.trainNum}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    putTrainingData(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.put(`hr/employees/trainings`, payload)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getCommittees(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `hr/employees/${payload.guid}/committees/startdate/${payload.startDate}/enddate/${payload.endDate}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getCommitteesDataByNumber(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `hr/employees/${payload.empId}/committees/${payload.commitNum}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getPublicservice(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `hr/employees/${payload.guid}/publicservices/startdate/${payload.startDate}/enddate/${payload.endDate}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getAcademicservices() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(`/hrreference/academicservices/`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getAcademicservicesSelectList(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrreference/trainningactiontypes/${payload.flagtype}/academicservices/${payload.academicServiceID}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postPublicservice(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `hr/employees/publicservices`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    delPublicservice(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.delete(
            `hr/employees/${payload.empId}/publicservices/${payload.serviceId}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getPublicserviceDataByNumber(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `hr/employees/${payload.empId}/publicservices/${payload.publicService}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    putPublicserviceDetail(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.put(
            `hr/employees/publicservices`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getArtculture(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `hr/employees/${payload.guid}/artcultures/startdate/${payload.startDate}/enddate/${payload.endDate}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    postArtculture(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `hr/employees/artcultures`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    delArtculture(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.delete(
            `hr/employees/${payload.empId}/artcultures/${payload.artCultureID}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getEmpartcultureDataByNumber(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `hr/employees/${payload.empId}/artcultures/${payload.artCultureId}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    putArtcultureDetail(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.put(
            `hr/employees/artcultures`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getLifeLong(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `hr/employees/${payload.guid}/letrains/startdate/${payload.startDate}/enddate/${payload.endDate}/statustype/${payload.statustype}`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    }
  }
}

export default history
